import Repository from './Repository';

const promotion = '/promotions';

export default {
  getPromotions(payload) {
    return Repository.get(`${promotion}/${payload}`);
  }
};
